module.exports = __webpack_public_path__ + "img/85.4cdfbfb2.png";